module.exports = __webpack_public_path__ + "static/WillBud-folder-OJPIII-WWW_pages-to-jpg-0014-d525ce9be8b4a7dad72aa240f05ad2af.jpg";